<template>
	<div :class="$store.state.mode">
		<Header class="header" ref="header" v-on:sideBarActive="sideBarActive"/>
		<v-touch v-on:swiperight="swipeActive" v-on:swipeleft="swipeDisable">
			<div class="darkmode" :class="($store.state.mode === 'dark') ? 'active' : 'false'">
				<div class="body" v-on:scroll.native="onScroll" :class="{'isDisabled': this.$store.state.isSidebarActive}">
					<!-- Top Card -->
					<div class="top-card--wrapper">
						<!-- Trending -->
						<div v-for="(item, index) in trending" :key="index + 2" class="card">
							<div v-ripple class="ripple" @click="play(item.audio)">				
								<div
									v-if="$store.state.isPlaying == item.audio"
									class="image--wrapper"
									:alt="item.creator + ', ' + item.title"
									:style="{ backgroundImage: `linear-gradient(120deg, rgba(27, 123, 70, .3), rgba(0, 0, 0, 1)), url(${item.cover})` }">
									<div class="top--wrapper">
										<div class="name--wrapper">
											<div class="name">
												{{ item.creator }}
											</div>
											<div class="verified">
												<img v-if="item.verified" src="../assets/icons/verified.png" class="ver" :alt="item.creator + ', ' + item.title">
											</div>
										</div>
										<div class="title">
											{{ item.title }}
										</div>
									</div>
									<div class="bot--wrapper">
										<div class="title">
											Trending Topic
										</div>
										<div class="subtitle">
											{{ timeConvert($store.state.seekTime) }} / {{ timeConvert(item.duration) }}
											<div class="play" v-if="$store.state.isStoping" @click="play()"><i class="material-icons">play_arrow</i></div>
											<div class="play" v-else-if="$store.state.isPlaying == null" @click="play()"><i class="material-icons">play_arrow</i></div>
											<div class="play" v-else @click="pause()"><i class="material-icons">pause</i></div>
										</div>
									</div>
								</div>
								<div
									v-else
									class="image--wrapper"
									:alt="item.creator + ', ' + item.title"
									:style="{ backgroundImage: `linear-gradient(-120deg, rgba(0, 0, 0, 1), rgba(0, 0, 0, .1)), url(${item.cover})` }">
									<div class="top--wrapper">
										<div class="name--wrapper">
											<div class="name">
												{{ item.creator }}
											</div>
											<div class="verified">
												<img v-if="item.verified" src="../assets/icons/verified.png" class="ver" :alt="item.creator + ', ' + item.creator">
											</div>
										</div>
										<div class="title">
											{{ item.title }}
										</div>
									</div>
									<div class="bot--wrapper">
										<div class="title">
											Trending Topic
										</div>
										<div class="subtitle">
											{{ timeConvert(item.duration) }}
										</div>
									</div>
								</div>
							</div>
						</div>
						<!-- event, donate, support -->
						<div v-for="(item, index) in topCard" :key="index" class="card">
							<div v-ripple @click="openURL(item.actionURl)" class="ripple">
								<div :alt="item.title + ', ' + item.subtitle + ', ' + item.creator + ', ' + item.category" class="image--wrapper" :style="{ backgroundImage: `linear-gradient(-120deg, rgba(0, 0, 0, 1), rgba(0, 0, 0, .1)), url(${item.img})` }">
									<div class="top--wrapper">
										<div class="name--wrapper">
											<div class="name">
												{{ item.title }}
											</div>
											<div class="verified">
												<img v-if="item.verified" src="../assets/icons/verified.png" class="ver" :alt="item.title + ', ' + item.subtitle + ', ' + item.category + ', ' + item.creator">
											</div>
										</div>
										<div class="title">
											{{ item.subtitle }}
										</div>
									</div>
									<div class="bot--wrapper">
										<div class="title">
											{{ item.category }}
										</div>
										<div class="subtitle">
											{{ item.creator }}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- New Releases -->
					<div v-if="newReleases.length > 0" class="heading">
						<div class="title">New releases</div>
						<div class="subtitle">From my subscriptions</div>
					</div>
					<div v-for="(item, index) in newReleases" :key="index" :class="{'active' : $store.state.isPlaying == item.audio}" class="audio-list--wrapper">
						<div class="image--wrapper">
							<div
								@click="$router.push({ name: 'ProfileCreator', params: { id: item.uid }})"
								:style="{ backgroundImage: `linear-gradient(rgba(255,255,255, 0), rgba(0, 0, 0, .5)), url(${item.cover})` }"
								class="image-profile"
								:alt="item.creator"
								>
							</div>
						</div>
						<div class="content--wrapper">
							<div class="creator--wrapper">
								<div class="name">{{ item.creator }}</div>
								<div class="verified--wrapper">
									<img v-if="item.verified" src="@/assets/icons/verified.png" alt="verified" class="verify">
								</div>
							</div>
							<div @click="play(item.audio)" class="title">{{ item.title }}</div>
							<div class="date" :class="($store.state.mode === 'dark') ? 'dark-date' : 'false'">{{ humanDate(item.created_at.toDate()).fromNow() }}
								<div :class="{'active' : $store.state.isPlaying == item.audio}" class="dot"></div> {{ timeConvert(item.duration) }} min
							</div>
						</div>
						<div class="play--wrapper" v-ripple v-if="$store.state.isStoping == item.audio" @click="play(item.audio)">
							<i class="material-icons">play_circle_outline</i>
						</div>
						<div class="play--wrapper" v-ripple v-else-if="$store.state.isPlaying == item.audio" @click="pause(item.audio)">
							<i class="material-icons">pause_circle_outline</i>
						</div>
						<div class="play--wrapper" v-ripple v-else @click="play(item.audio)">
							<i class="material-icons">play_circle_outline</i>
						</div>
					</div>
					<!-- Popular Creator -->
					<div class="heading">
						<div class="title">Popular creator</div>
						<div class="subtitle">by editor's choice</div>
					</div>
					<div class="audio-card--wrapper">
						<div v-for="(item, index) in creator" :key="index" class="img--wrapper">
							<div v-ripple class="ripple">
								<div 
									@click="$router.push({ name: 'ProfileCreator', params: { id: item.id }})"
									:style="{ backgroundImage: `linear-gradient(rgba(255,255,255, 0), rgba(0, 0, 0, 1)), url(${item.cover})`}"
									class="image-audio"
									:alt="item.podcastName">
								</div>
							</div>
							<div class="content--wrapper">
								<div class="creator--wrapper">
									<div class="creator">
										{{ item.podcastName.substring(0,25) }}{{ item.podcastName.length >= 25 ? '..' : '' }}
									</div>
									<img v-if="item.verified" src="@/assets/icons/verified.png" class="verified">
								</div>
								<div class="subtitle" style="text-transform: lowercase;">{{ item.subscriber }} Subscribers</div>
							</div>
						</div>
					</div>
					<!-- Categories -->
					<div v-for="(category) in categories" :key="category.id">
						<div class="heading">
							<div class="title">{{ category.name }}</div>
							<div class="subtitle">{{ category.subtitle }}</div>
						</div>
						<div class="audio-card--wrapper">
							<div v-for="(item, index) in category.episodes" :key="index" class="img--wrapper">
								<div v-ripple @click="play(item.audio)" class="ripple">
									<div v-if="$store.state.isPlaying == item.audio" :style="{ backgroundImage: `linear-gradient(120deg, rgba(27, 123, 70, .70), rgba(0, 0, 0, 1)), url(${item.cover})` }" class="image-audio" :alt="item.creator + ', ' + item.title">
										<div class="duration--wrapper">
											<div class="duration">
												{{ timeConvert($store.state.seekTime) }} / {{ timeConvert(item.duration) }}
												<div class="play" v-if="$store.state.isStoping" @click="play()"><i class="material-icons">play_arrow</i></div>
												<div class="play" v-else-if="$store.state.isPlaying == null" @click="play()"><i class="material-icons">play_arrow</i></div>
												<div class="play" v-else @click="pause()"><i class="material-icons">pause</i></div>
											</div>
										</div>
									</div>
									<div v-else :style="{ backgroundImage: `linear-gradient(rgba(255,255,255, 0), rgba(0, 0, 0, 1)), url(${item.cover})` }" class="image-audio" :alt="item.creator + ', ' + item.title">
										<div class="duration--wrapper">
											<div class="duration"> {{ timeConvert(item.duration) }}</div>
										</div>
									</div>
								</div>
								<div class="content--wrapper" @click="$router.push({ name: 'ProfileCreator', params: { id: item.id }})">
									<div v-if="$store.state.isPlaying == item.audio" class="title" :class="{'active' : $store.state.isPlaying == item.audio}">
										<marquee>{{ item.title }}</marquee>
									</div>
									<div v-else class="title">
										{{ item.title.substring(0,25) }}{{ item.title.length >= 25 ? '..' : '' }}
									</div>
									<div class="creator--wrapper">
										<div class="creator-cat" @click="$router.push({ name: 'ProfileCreator', params: { id: item.uid }})">{{ item.creator.substring(0,25) }}{{ item.creator.length >= 25 ? '..' : ''}}</div>
										<div class="verified-cat--wrapper">
											<img v-if="item.verified" src="@/assets/icons/verified.png" class="verify-cat">
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</v-touch>
	</div>
</template>

<script>
import Header from '@/components/Header.vue'
import db from '@/db'
export default {
	name: 'Home',
	components: {
		Header,
	},
	data() {
		return {
			isSidebarActive: false,
			trending: [],
			topCard: [
				{
					title: "Pengajian TASTAFI bersama Abu MUDI",
					subtitle: "Mesjid Raya Baiturrahman Banda Aceh, Jum'at 20:00 WIB, 3 Juli 2020",
					img: require("@/assets/img/pengajian_by_abu_mudi.webp"),
					creator: "Abu MUDI",
					category: "Pengajian",
					actionURl: 'https://www.youtube.com/watch?v=SI_0affyVKM'
				},
				{
					title: "Simpan hartamu di langit!",
					subtitle: "Hidup mulia dengan berbagi, dari umat untuk umat",
					creator: "Sedekah Kreatif",
					img: require("@/assets/img/donate.webp"),
					category: "Donate",
					actionURl: 'https://instagram.com/sedekahkreatif?igshid=145e2yas4n27j'
				},
				{
					title: "Wanna contribute?",
					subtitle: "Your contribution will make this app even better",
					creator: "app developer",
					img: require("@/assets/img/support.webp"),
					category: "Support",
					actionURl: 'https://kitabisa.thicom/jitube'
				},
			],
			creator : null,
			episodes : [],
			newReleases: [],
			categories: []
		}
	},
	methods: {
		sideBarActive: function(sidebarStatus) {
			this.isSidebarActive = sidebarStatus
		},
		swipeActive: function() {
			this.$store.commit('setSidebarActive',true)
		},
		swipeDisable: function() {
			this.$store.commit('setSidebarActive',false)
		},
		play: function(audioUrl) {
			this.$store.commit('playSound', audioUrl)
		},
		pause: function(audioUrl) {
			this.$store.commit('pauseSound', audioUrl)
		},
		openURL: function(url) {
			window.open(url,'_blank')
		}
	},
	firestore() {
		return {
			creator : db.collection('creator').orderBy('subscriber','desc'),
		}
	},
	beforeCreate() {
		let _this = this
		//get trending episode
		db.collection('episodes').orderBy('listener','desc').limit(1).get().then((audioData) => {
			audioData.forEach(function(doc) {
				db.collection('creator').doc(doc.data().uid).get().then(function(creator) {	
					_this.trending.push({
						audio: doc.data().audio,
						created_at: doc.data().created_at,
						duration: doc.data().duration,
						title: doc.data().title,
						listener: doc.data().listener,
						uid: doc.data().uid,
						creator: creator.data().podcastName,
						cover: creator.data().cover,
						verified: creator.data().verified
					});
				})
			})
		})
		//get new releases
		db.collection('subscriber').where('uid','==',this.$store.state.currentUser.uid).onSnapshot((subs) => {
			_this.newReleases = []
			subs.forEach((sub) => {
				db.collection('episodes').where('uid','==',sub.data().cid).orderBy('created_at','desc').limit(1).get().then((episodes) => {
					episodes.forEach((episode) => {
						db.collection('creator').doc(episode.data().uid).get().then((creator) => {
							_this.newReleases.push({
								audio: episode.data().audio,
								created_at: episode.data().created_at,
								duration: episode.data().duration,
								title: episode.data().title,
								listener: episode.data().listener,
								uid: episode.data().uid,
								creator: creator.data().podcastName,
								cover: creator.data().cover,
								verified: creator.data().verified,
							})
						})
					})
				})
			})
		})
		//get each category episode 
		db.collection('categories').get().then(function(snapshot) {
			snapshot.forEach(function(doc) {
				let newData = {
					name : doc.data().name,
					subtitle : doc.data().subtitle,
					episodes: []
				}
				db.collection('episodeCategory').where('cid','==',doc.id).get().then((episodes) => {
					let episodeCounting = 0
					episodes.forEach((episode) => {
						db.collection('episodes').doc(episode.data().eid).get().then((dataEpisode) => {
							db.collection('creator').doc(dataEpisode.data().uid).get().then(function(creator) {	
								newData.episodes.push({
									audio: dataEpisode.data().audio,
									created_at: dataEpisode.data().created_at,
									duration: dataEpisode.data().duration,
									title: dataEpisode.data().title,
									listener: dataEpisode.data().listener,
									uid: dataEpisode.data().uid,
									creator: creator.data().podcastName,
									cover: creator.data().cover,
									verified: creator.data().verified
								})
								episodeCounting++
								if (episodeCounting == episodes.size) {
									_this.categories.push(newData)
								}
							})
						})
					})
				})
			});
		})
	}
};
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
	display: none;
}
.body {
	z-index: -1;
	font-size: 62.5%;
	padding-top: 4.5rem;
	margin-bottom: 5rem;
	will-change: transform, filter;
	transition: .5s;
	&.isDisabled {
		transform: translateX(55%);
		filter: grayscale(100%);
	}
}
.darkmode.active .body {
	background-color: #000;
	color: #fff;
}
.top-card--wrapper {
	width: 100vw;
	display: flex;
	overflow-x: auto;
	margin: 0 !important;
	padding: .7rem 1.2rem;
	.card {
		padding: 0 .3rem;
	}
	.card:last-child {
		padding-right: 5% !important;
	}
	.image--wrapper {
		display: flex;
		flex-flow: column;
		justify-content: space-between;
		color: rgb(255,255,255);
		width: 18rem;
		height: 10rem;
		position: relative;
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center;
		border-radius: 22px;
		overflow: hidden;
		padding: 1rem;
		.top--wrapper {
			display: flex;
			flex-flow: column;
			.name--wrapper {
				display: flex;
				justify-content: flex-end;
				margin-bottom: .25rem;
				.name {
					font-size: 12px;
				}
				.verified {
					margin-left: .15rem;
					display: flex;
					align-items: center;
					height: 14px;
					img {
						height: 12px;
					}
				}
			}
			.title {
				display: flex;
				text-align: end;
				justify-content: flex-end;
				font-size: 10px;
				opacity: .9;
				letter-spacing: .015rem;
			}
		}
		.bot--wrapper {
			display: flex;
			justify-content: inherit;
			align-items: flex-end;
			.title {
				width: 8rem;
				padding: .2rem;
				opacity: .95;
				font-size: 24px;
				line-height: 1;
				font-weight: bold;
				text-transform: capitalize;
			}
			.subtitle {
				display: flex;
				align-items: center;
				justify-content: center;
				color: #fff;
				font-size: 10px;
				padding: .6rem;
				border-radius: 12px;
				background: rgba(0, 0, 0, .5);
				text-transform: capitalize;
				.play {
					padding: 0 0 0 .5rem;
					display: flex;
					transition: 0.25s ease-in-out;
					i {
						font-size: 15px;
					}
					&:active {
						opacity: 0.75;
						transform: scale(0.90);
					}
				}
			}
		}
		
	}
	.ripple {
		border-radius: 22px;
	}
	.ripple:active {
		transition: 1.2s;
		opacity: 0.9;
	}
}
</style>